import { unsetAll } from "../../event/head";
import { createProxy } from "../proxy/proxy";
import type { AssignOptions, Unset } from "../proxy/proxy.types";
import { configSync } from "../proxy/proxyConfig";
import {
  assignMembers,
  cleanupStore,
  removeTargetProps,
  setupReady,
  setupTargetProps,
} from "../store/store";
import type { ProxyTarget, TargetStore } from "../store/store.types";
import { assertNamespaceFree } from "../utils/utils";
import { onMessageIfGlobal } from "./broadcast";
import type { DefineSignalOptions } from "./event.types";
import {
  addListener,
  dispatchSignal,
  dispatchSignalInternal,
  notififyStartIfDefined,
} from "./private";

/**
 *
 *
 *
 *
 *
 *
 */
export const unsetSignal = (
  store: TargetStore,
  target: ProxyTarget,
  unsetListeners: Unset,
): void => {
  cleanupStore(store, target);
  setupReady(store);
  setupTargetProps(target, ...assignMembers);
  return unsetListeners();
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function assignSignal(
  store: TargetStore,
  target: ProxyTarget,
  defineOptions: DefineSignalOptions<unknown> = {},
  assignOptions: AssignOptions = {},
): Unset {
  assertNamespaceFree(store, "create event topic for", assignOptions);
  cleanupStore(store, target);

  /*                                          */
  if (assignOptions.clean) store.listeners.splice(0);

  /*                                     */
  const { listeners = [] } = defineOptions;

  /*                                                                */
  const unsetListeners: (Unset | undefined)[] = listeners.map((l) => addListener(store, l));

  /*                                                */
  store.isSig = true;
  removeTargetProps(target, ...assignMembers);
  store.onReady(createProxy(target, configSync));

  /*                                                                                            */
  store.broadcast = !!defineOptions.broadcast;
  unsetListeners.push(onMessageIfGlobal(store, dispatchSignalInternal));

  /*                                                                        */
  if ("detail" in defineOptions || defineOptions.start) {
    store.detail = defineOptions.detail;
    store.start = defineOptions.start;

    /*                                                          */
    /*                                                             */
    const hasNotified = notififyStartIfDefined(store, store.listeners.length > 0);
    if (!hasNotified) {
      store.detail = undefined;
      dispatchSignal(store, [defineOptions.detail, { retain: true }]);
    }
  }

  /*                    */
  return unsetSignal.bind(undefined, store, target, unsetAll(...unsetListeners));
}
